import { PartFinderFeedback, SetPartFinderFeedbackRequest } from '@/api/api';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { AxiosApiError } from '@/types/apiError';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PART_FINDER_FEEDBACK_QUERY_KEY } from './usePartFinderFeedback';

interface SetPartFinderFeedbackVariables extends SetPartFinderFeedbackRequest {
  targetId: string;
}

export const useSetPartFinderFeedback = (reportId: string) => {
  const queryClient = useQueryClient();
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  return useMutation<PartFinderFeedback, AxiosApiError, SetPartFinderFeedbackVariables>({
    mutationFn: async ({ targetId, ...data }) => {
      const response = await api.tenants.setPartFinderFeedback(tenantId, reportId, targetId, data);
      return response.data.feedback;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [PART_FINDER_FEEDBACK_QUERY_KEY, reportId] });
    },
  });
};
